export const loginReducerSelector = state => {
    return{
        isLoggedIn:state.loginReducer.isLoggedIn,
        userInfo:state.loginReducer.userInfo,
        isWebAppReady:state.loginReducer.isWebAppReady
    }
};
